import { Formik } from 'formik';
import React, { useMemo, useState } from 'react';

import SwitchField from '@components/Form/SwitchField';
import { useSubscribeToNewsletter, useUnsubscribeFromNewsletter } from '@hooks';
import { Theme } from '@interfaces/global';

import StepContainer from './StepContainer';

export interface Newsletter {
  card_image_path: string;
  current_user_subscribed: boolean;
  frequency: string;
  id: number;
  name: string;
}

interface StepNewslettersProps {
  newsletters: Newsletter[];
  nextStep: () => void;
}

interface NewsletterItemProps {
  item: Newsletter;
  setError: (error: string) => void;
}

const StepNewsletters = ({ newsletters, nextStep }: StepNewslettersProps) => {
  const [error, setError] = useState<string>('');

  const initialValues = useMemo(
    () =>
      newsletters?.reduce((newsletterFields, newsletter) => {
        newsletterFields[newsletter.name] = newsletter?.current_user_subscribed;
        return newsletterFields;
      }, {}),
    [newsletters]
  );

  return (
    <StepContainer
      heading="Stay on Top of Tech News"
      subheading="Which newsletters do you want to receive?"
      nextStep={nextStep}
      error={error}
    >
      <Formik onSubmit={null} initialValues={initialValues}>
        <ul className="onboarding-togglelist">
          {newsletters?.map((n) => <NewsletterItem key={n.name} item={n} setError={setError} />)}
        </ul>
      </Formik>
    </StepContainer>
  );
};

const NewsletterItem = ({ item, setError }: NewsletterItemProps) => {
  const { mutate: subscribeToNewsletter, isLoading: isFollowNewsletterLoading } =
    useSubscribeToNewsletter();
  const { mutate: unsubscribeFromNewsletter, isLoading: isUnFollowNewsletterLoading } =
    useUnsubscribeFromNewsletter();

  const handleSwitchToggle = ({ checked, id }: { checked: boolean; id: string }) => {
    try {
      setError('');
      const subscribeMethod = checked ? subscribeToNewsletter : unsubscribeFromNewsletter;
      subscribeMethod({ newsletter_id: id });
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <li>
      <div className="onboarding-newsletter">
        <img src={`https://tii.imgix.net/production/${item.card_image_path}`} />
        <div>
          <span>{item.frequency}</span>
          <h3>{item.name}</h3>
        </div>
      </div>
      <SwitchField
        colorTheme={Theme.Light}
        id={`${item.id}`}
        name={item.name}
        onChangeCallBack={handleSwitchToggle}
        disabled={isFollowNewsletterLoading || isUnFollowNewsletterLoading}
      />
    </li>
  );
};

export default StepNewsletters;
